<dashboardnav>

    <cradua-lease-expiration
    [landtitles]="landtitles$ | async"
    [countries]="countries$ | async"
  
    (changeEmit)="onSubmitLeaseExpiration($event)"
    (deleteEvent)="onDeleteLeaseExpiration($event)"
    *ngIf="
    !(isLoadingLandTitle$ | async ) &&
    !(isLoadingLeaseExpiration$ | async )
    "
    >
  </cradua-lease-expiration>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="
    (isLoadingLandTitle$ | async ) ||
    (isLoadingLeaseExpiration$ | async )
    "
  >
    </mrsoftapps-epims-reference-spinner>
  </dashboardnav>
  